import React from 'react';
import linkifyHtml from 'linkifyjs/html';


const ReplyMessage = (props) => {
    // console.log('props',props)
    // const replyparticularChat = (message) =>{
    //     let chatmasterid = props.chatMasterId;
    //     let type = props.messageType;
    //   }
      return (
        <div>
                  
                    <div className="sc-message--text">
    {props.message.includes('/Param') &&<span style={{cursor:"pointer"}} className="text-primary" dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                        </span>
                      }

    {!props.message.includes('/Param') &&<span className="chatspan" dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                      </span>
    }
    </div>

    {props.mediaBase64Content!=null?<img className="mediaDisplay" alt="user" src={`data:image/jpeg;base64,${props.mediaBase64Content}`}/>:""}
    
    <hr></hr>
    
                    </div>      
        )
  
      }

export default ReplyMessage;
